module.exports = __webpack_public_path__ + "img/faxian.38a81a17.png";